import * as React from 'react';
import {Link} from 'react-router-dom';

const rootLink = '/NLSAdmin2/blog';
export const BlogManagerNav = (): JSX.Element => {
  return (
    <nav className="pt-1 pb-1">
      <ul className="flex flex-row justify-left">
        <li className="pr-4">
          <Link to={rootLink + '/newfromtemplate'}>New From Template</Link>
        </li>
        <li className="pr-4">
          <Link to={rootLink + '/filter'}>Filter</Link>
        </li>
      </ul>
    </nav>
  );
};

export const BlogManagerNewTemplateNav = (): JSX.Element => {
  return (
    <nav className="pt-1 pb-1">
      <ul className="flex flex-row justify-left">
        <li className="pr-4">
          <Link to={rootLink + '/newfromtemplate/facomps'}>FA Comps</Link>
        </li>
        <li className="pr-4">
          <Link to={rootLink + '/newfromtemplate/facompresult'}>
            FA Comp Result
          </Link>
        </li>
      </ul>
    </nav>
  );
};
